import script from "./FeaturedFixtureOverviewOdd.vue?vue&type=script&setup=true&lang=js"
export * from "./FeaturedFixtureOverviewOdd.vue?vue&type=script&setup=true&lang=js"

import "./FeaturedFixtureOverviewOdd.vue?vue&type=style&index=0&id=7d275c6f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d275c6f"]])

export default __exports__